const Translation = {
  error: "Une erreur inattendue s'est produite.",
  errorHeader: "Opération échouée",
  successHeader: "Opération réussie",
  success: "L'opération a été effectuée avec succès.",
  transactionError:"Cette transaction ne peut pas être annulée car elle est hors date"
};

export default Translation;
